import {AppStore} from '../AppStore';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {RxSubjects} from "../state/RxSubjectsState";
import {NotesActions} from "../redux/NotesSlice";
import {DB} from "../db/DbManager";

const SEARCH_DEBOUNCE_TIME = 500;

export function registerNotesSearchTextSubjectHandler(store: AppStore) {
    RxSubjects.notesSearchText$.pipe(
        distinctUntilChanged(),
        debounceTime(SEARCH_DEBOUNCE_TIME),
    ).subscribe({
        next: async newSearchText => {
            try {
                const {notesState} = store.getState();
                const pages = await DB.getAllNotePages();
                if (!newSearchText) {
                    const sectionClientId = notesState.selectedSectionClientId ?? notesState.sections[0].ClientId;
                    const pages = await DB.getNoteSectionPages(sectionClientId);
                    store.dispatch(NotesActions.selectNoteSection({pages, pageClientId: notesState.selectedPageClientId, sectionClientId}));
                    store.dispatch(NotesActions.setNotesSearchResults({searchResultSections: undefined, searchResultPages: undefined}));
                    return;
                }
                const lowerSearchText = newSearchText?.toLowerCase() ?? "";
                const searchResultPages = pages.filter(page => page.HtmlContent?.toLowerCase().includes(lowerSearchText) || page.Name.toLowerCase().includes(lowerSearchText));
                const searchResultSectionIds = new Set<string>(searchResultPages.map(page => page.ClientSectionId ?? ""));
                const searchResultSections = notesState.sections.filter(section => searchResultSectionIds.has(section.ClientId ?? ""));

                store.dispatch(NotesActions.setNotesSearchResults({searchResultSections, searchResultPages}));

            } catch (e) {
                console.error(e);
            }
        }
    });
}
